var _rect, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaptionGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 67,
    viewBox: "0 0 63 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.125,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_2713_8326)",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2713_8326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6328 10.5107H25.6172C23.1402 10.5107 21.125 12.5259 21.125 15.0029V20.4717C21.125 22.7502 22.83 24.6379 25.0312 24.9258V28.9024C25.0312 29.1394 25.174 29.3531 25.393 29.4438C25.4654 29.4738 25.5416 29.4884 25.6171 29.4884C25.7695 29.4884 25.9194 29.4288 26.0315 29.3167L30.3844 24.9639H36.6328C39.1098 24.9639 41.125 22.9487 41.125 20.4717V15.0029C41.125 12.5259 39.1098 10.5107 36.6328 10.5107ZM39.9531 20.4717C39.9531 22.3025 38.4636 23.792 36.6328 23.792H30.1417C29.9862 23.792 29.8372 23.8537 29.7274 23.9636L26.2031 27.4879V24.3779C26.2031 24.0543 25.9408 23.792 25.6172 23.792C23.7864 23.792 22.2969 22.3025 22.2969 20.4717V15.0029C22.2969 13.1721 23.7864 11.6826 25.6172 11.6826H36.6328C38.4636 11.6826 39.9531 13.1721 39.9531 15.0029V20.4717Z",
    fill: "url(#paint1_linear_2713_8326)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4375 16.2207C25.4682 16.2207 24.6797 17.0093 24.6797 17.9785C24.6797 18.9478 25.4682 19.7363 26.4375 19.7363C27.4068 19.7363 28.1953 18.9478 28.1953 17.9785C28.1953 17.0093 27.4068 16.2207 26.4375 16.2207ZM26.4375 18.5645C26.1144 18.5645 25.8516 18.3016 25.8516 17.9785C25.8516 17.6554 26.1144 17.3926 26.4375 17.3926C26.7606 17.3926 27.0234 17.6554 27.0234 17.9785C27.0234 18.3016 26.7606 18.5645 26.4375 18.5645Z",
    fill: "url(#paint2_linear_2713_8326)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.125 16.2207C30.1557 16.2207 29.3672 17.0093 29.3672 17.9785C29.3672 18.9478 30.1557 19.7363 31.125 19.7363C32.0943 19.7363 32.8828 18.9478 32.8828 17.9785C32.8828 17.0093 32.0943 16.2207 31.125 16.2207ZM31.125 18.5645C30.8019 18.5645 30.5391 18.3016 30.5391 17.9785C30.5391 17.6554 30.8019 17.3926 31.125 17.3926C31.4481 17.3926 31.7109 17.6554 31.7109 17.9785C31.7109 18.3016 31.4481 18.5645 31.125 18.5645Z",
    fill: "url(#paint3_linear_2713_8326)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8125 16.2207C34.8432 16.2207 34.0547 17.0093 34.0547 17.9785C34.0547 18.9478 34.8432 19.7363 35.8125 19.7363C36.7818 19.7363 37.5703 18.9478 37.5703 17.9785C37.5703 17.0093 36.7818 16.2207 35.8125 16.2207ZM35.8125 18.5645C35.4894 18.5645 35.2266 18.3016 35.2266 17.9785C35.2266 17.6554 35.4894 17.3926 35.8125 17.3926C36.1356 17.3926 36.3984 17.6554 36.3984 17.9785C36.3984 18.3016 36.1356 18.5645 35.8125 18.5645Z",
    fill: "url(#paint4_linear_2713_8326)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.613 63.21C8.259 63.21 10.331 61.46 10.681 58.856H8.427C8.175 60.298 7.069 61.306 5.641 61.306C3.919 61.306 2.757 59.934 2.757 57.96C2.757 56 3.919 54.642 5.641 54.642C7.069 54.642 8.189 55.636 8.427 57.078H10.681C10.331 54.502 8.259 52.738 5.613 52.738C2.785 52.738 0.573 55.02 0.573 57.96C0.573 60.914 2.785 63.21 5.613 63.21ZM16.4509 63H18.0329V58.296C18.0329 56.462 16.8849 55.384 14.9249 55.384C13.1189 55.384 11.8729 56.504 11.7609 58.226H13.5109C13.5809 57.386 14.0849 56.896 14.9249 56.896C15.7369 56.896 16.2129 57.386 16.2129 58.226V58.674C15.7509 58.618 15.3869 58.59 14.9669 58.59C12.7829 58.59 11.6069 59.374 11.6069 60.83C11.6069 62.23 12.6429 63.14 14.1969 63.14C15.2189 63.14 15.9609 62.776 16.4509 62.076V63ZM13.4409 60.774C13.4409 60.102 13.9869 59.752 15.0929 59.752C15.4289 59.752 15.7509 59.78 16.2129 59.85V60.382C16.2129 61.25 15.6109 61.796 14.6169 61.796C13.8889 61.796 13.4409 61.404 13.4409 60.774ZM27.1718 59.262C27.1718 57.064 25.8698 55.384 23.8538 55.384C22.9018 55.384 22.0758 55.818 21.5018 56.616V55.524H19.7098V65.702H21.6558V62.034C22.2158 62.762 22.9718 63.14 23.8538 63.14C25.8698 63.14 27.1718 61.474 27.1718 59.262ZM25.1698 59.262C25.1698 60.69 24.3718 61.404 23.4198 61.404C22.4678 61.404 21.6698 60.676 21.6698 59.262C21.6698 57.848 22.4678 57.106 23.4198 57.106C24.3718 57.106 25.1698 57.862 25.1698 59.262ZM32.9848 61.11C32.7048 61.264 32.3688 61.348 32.0048 61.348C31.3048 61.348 30.9128 60.998 30.9128 60.13V57.19H33.0548V55.524H30.9128V53.312H28.9808V55.524H27.4688V57.19H28.9808V60.578C28.9808 62.258 29.9468 63.14 31.4868 63.14C32.0608 63.14 32.5088 63.042 32.9848 62.804V61.11ZM36.497 53.788C36.497 53.102 35.965 52.612 35.195 52.612C34.439 52.612 33.907 53.102 33.907 53.788C33.907 54.446 34.439 54.936 35.195 54.936C35.965 54.936 36.497 54.446 36.497 53.788ZM36.189 63V55.524H34.243V63H36.189ZM41.2247 63.14C43.3947 63.14 45.0187 61.432 45.0187 59.262C45.0187 57.078 43.3947 55.384 41.2247 55.384C39.0547 55.384 37.4307 57.078 37.4307 59.262C37.4307 61.432 39.0547 63.14 41.2247 63.14ZM41.2247 61.418C40.2587 61.418 39.4327 60.648 39.4327 59.262C39.4327 57.876 40.2587 57.12 41.2247 57.12C42.1907 57.12 43.0167 57.876 43.0167 59.262C43.0167 60.648 42.1907 61.418 41.2247 61.418ZM48.2066 58.926C48.2066 57.722 48.8646 57.106 49.6346 57.106C50.5166 57.106 50.9506 57.722 50.9506 58.828V63H52.8826V58.17C52.8826 56.364 51.8466 55.384 50.3486 55.384C49.3686 55.384 48.5986 55.846 48.0526 56.588V55.524H46.2606V63H48.2066V58.926ZM60.8734 60.606C60.8734 59.528 60.1314 58.856 58.6754 58.576L57.2334 58.31C56.5614 58.184 56.2534 58.002 56.2534 57.554C56.2534 57.078 56.7294 56.812 57.4434 56.812C58.2694 56.812 58.8154 57.26 58.8854 57.988H60.7474C60.6074 56.378 59.3194 55.384 57.4434 55.384C55.5814 55.384 54.3914 56.35 54.3914 57.736C54.3914 58.898 55.2034 59.64 56.5474 59.878L57.8914 60.13C58.6054 60.27 58.9134 60.466 58.9134 60.942C58.9134 61.474 58.3394 61.712 57.5834 61.712C56.6174 61.712 55.9594 61.222 55.9454 60.452H54.0834C54.2374 62.118 55.4274 63.14 57.5554 63.14C59.6834 63.14 60.8734 62.174 60.8734 60.606Z",
    fill: "url(#paint5_linear_2713_8326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2713_8326",
    x1: 51.125,
    y1: 37.4286,
    x2: 8.01462,
    y2: 32.9931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#356571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#562876"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2713_8326",
    x1: 41.1893,
    y1: 35.0752,
    x2: 15.8982,
    y2: 25.7705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2713_8326",
    x1: 28.2066,
    y1: 20.7713,
    x2: 23.7075,
    y2: 19.2007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2713_8326",
    x1: 32.8941,
    y1: 20.7713,
    x2: 28.395,
    y2: 19.2007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2713_8326",
    x1: 37.5816,
    y1: 20.7713,
    x2: 33.0825,
    y2: 19.2007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2713_8326",
    x1: 62.3243,
    y1: 72.5935,
    x2: 23.5834,
    y2: 28.4614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2713_8326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(21.125 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptionGradient);
export default __webpack_public_path__ + "static/media/caption_gradient.9d0acbf2e507becd45f06deed7e9ae91.svg";
export { ForwardRef as ReactComponent };